import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import { fetchScenarioInformation } from '../../../../actions/bulkScenarioGroup/bulkScenarioGroupActions';
import PropTypes from 'prop-types';


function Info(props) {

    const showScenarioInfo = (e) => {
        const scenarioId = e.target.id
        const scenarioInfo = props.info.tasks[scenarioId];
        props.updateScenarioInfo(scenarioInfo);
    }

    return(
        <Draggable draggableId={props.task.id} index={props.index}>
            {(provided, snapshot) => {
                return (
                    <Card
                        style={{
                            backgroundColor: snapshot.isDragging ? '#B0FF44' : '#FFFFFF',
                            color: snapshot.isDraggingOver ? '#464646' : 'black',
                            padding: '8px',
                            marginBottom: '2px'
                        }}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                    >
                        <Card.Header>
                            <Row>
                                <Col>
                                    <h6>{ props.task.content }</h6>
                                </Col>
                                <Col>
                                    <Button
                                        variant="secondary"
                                        id={props.task.id}
                                        onClick={showScenarioInfo}
                                    >
                                        Info
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Card>
                )
            }}
        </Draggable>
    )
}

Info.propTypes={
    info:PropTypes.object,
    updateScenarioInfo:PropTypes.func,
    task:PropTypes.object,
    index:PropTypes.number,
}

const mapStateToProps = (state) => ({
    info: state.bulkScenarioGroup.info
})

const mapStateToDispatch = (dispatch) => ({
    updateScenarioInfo: (data) => dispatch(fetchScenarioInformation(data)),
})

export default connect(mapStateToProps, mapStateToDispatch)(Info)